// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton-container-3CcC1","text":"IconButton-text-36kOo"};